// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  @page {
    margin-left: 0.5in;
    margin-right: 0.5in;
    margin-top: 0;
    margin-bottom: 0;
  }
  body {
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
}
.bedboard-print-layout {
  width: 100%;
  padding-left: 0.7rem !important;
  padding-right: 0.7rem !important;
  margin-top: 12px !important;
}
@media print {
  .bedboard-print-layout {
    padding-left: 0 !important;
    padding-right: 0 !important;
    transform: none !important;
    width: unset !important;
  }
}
.bedboard-print-layout .bedboard-tables-wrapper {
  display: grid;
  gap: 4px;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 5px;
  page-break-after: always;
  height: 1155px;
}
.bedboard-print-layout .bedboard-tables-wrapper-0 {
  height: 1100px;
}
@media print {
  .bedboard-print-layout .bedboard-tables-wrapper {
    height: auto !important;
    transform: none !important;
  }
}

.export-bedboard-to-pdf-modal .table-header b {
  font-weight: 700;
}
.export-bedboard-to-pdf-modal .modal-header .pdf-title {
  word-break: break-all;
}
.export-bedboard-to-pdf-modal .modal-body {
  width: 100%;
  overflow-y: visible;
  overscroll-behavior: none;
  background-color: #ffffff;
  max-width: 800px;
  margin: auto;
  overscroll-behavior: initial;
}
.export-bedboard-to-pdf-modal .modal-body ::-webkit-scrollbar {
  display: none;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout {
  padding: 32px 32px 0;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout {
  max-width: 100%;
  padding: 0;
  margin-top: 32px;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .table-header {
  font-size: 14px;
  line-height: 14px;
}
@media print {
  .export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .table-header {
    transform: none !important;
  }
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-block {
  width: 176px;
  page-break-after: always;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-block .unit-in-house-title {
  margin-top: 15px;
  font-size: 10px;
  margin-bottom: 0px !important;
  background-color: transparent;
}
@media print {
  .export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-block .unit-in-house-title {
    margin-top: 15px !important;
  }
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-block .unit-title {
  font-size: 14px;
  margin-top: 5px !important;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-block .unit-table {
  max-height: unset;
  margin-top: 15px !important;
  overflow-y: visible !important;
  overflow-x: hidden;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-block .unit-table .tr.is-first-room-bed:not(:first-child) .td {
  border-top: 1px solid #98a2b3;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-block .unit-table .td {
  padding: 0px 3px;
  font-size: 11px !important;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-block .unit-table .td.room-col {
  min-width: 40px;
  width: 40px !important;
  max-width: 40px !important;
  overflow: hidden;
  white-space: nowrap;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-block .unit-table .td.bed-col {
  min-width: 15px;
  width: 15px !important;
  max-width: 15px !important;
  color: #667085;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-block .unit-table .td.resident-col {
  min-width: 95px;
  width: 95px !important;
  max-width: 95px !important;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-block .unit-table .td.code-col {
  width: 20px;
  max-width: 20px;
  min-width: 20px;
  text-align: center;
  font-size: 11px;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-in-house-title {
  font-size: 12px;
}
.export-bedboard-to-pdf-modal .modal-body .bedboard-print-layout .unit-title {
  font-size: 14px;
}
.export-bedboard-to-pdf-modal .modal-body .notes-print-block {
  margin-left: 12px;
  margin-right: 12px;
  page-break-before: always;
}
.export-bedboard-to-pdf-modal .modal-body .notes-print-block .th {
  padding: 13px 24px;
}
.export-bedboard-to-pdf-modal .modal-body .notes-print-block .td {
  padding: 13px 24px;
  font-size: 14px !important;
}
.export-bedboard-to-pdf-modal .modal-body .notes-print-block .code-col,
.export-bedboard-to-pdf-modal .modal-body .notes-print-block .amount-col {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/bedboard/components/ExportToPDF/styles.scss"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAA;IACA,mBAAA;IACA,aAAA;IACA,gBAAA;EACF;EAEA;IACE,yBAAA;IACA,iCAAA;EAAF;AACF;AAGA;EACE,WAAA;EACA,+BAAA;EACA,gCAAA;EACA,2BAAA;AADF;AAGE;EANF;IAOI,0BAAA;IACA,2BAAA;IACA,0BAAA;IACA,uBAAA;EAAF;AACF;AAEE;EACE,aAAA;EACA,QAAA;EACA,qCAAA;EACA,eAAA;EAEA,wBAAA;EAEA,cAAA;AAFJ;AAII;EACE,cAAA;AAFN;AAKI;EAdF;IAeI,uBAAA;IACA,0BAAA;EAFJ;AACF;;AAQI;EACE,gBAAA;AALN;AAUI;EACE,qBAAA;AARN;AAYE;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EAEA,4BAAA;AAXJ;AAaI;EACE,aAAA;AAXN;AAcI;EACE,oBAAA;AAZN;AAeI;EACE,eAAA;EACA,UAAA;EACA,gBAAA;AAbN;AAeM;EACE,eAAA;EACA,iBAAA;AAbR;AAeQ;EAJF;IAKI,0BAAA;EAZR;AACF;AAeM;EACE,YAAA;EACA,wBAAA;AAbR;AAeQ;EACE,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,6BAAA;AAbV;AAeU;EANF;IAOI,2BAAA;EAZV;AACF;AAeQ;EACE,eAAA;EACA,0BAAA;AAbV;AAgBQ;EACE,iBAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;AAdV;AAkBc;EACE,6BAAA;AAhBhB;AAqBU;EACE,gBAAA;EACA,0BAAA;AAnBZ;AAqBY;EACE,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;AAnBd;AAsBY;EACE,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;AApBd;AAuBY;EACE,eAAA;EACA,sBAAA;EACA,0BAAA;AArBd;AAwBY;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAtBd;AA4BM;EACE,eAAA;AA1BR;AA6BM;EACE,eAAA;AA3BR;AA+BI;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;AA7BN;AA8BM;EACE,kBAAA;AA5BR;AA+BM;EACE,kBAAA;EACA,0BAAA;AA7BR;AAgCM;;EAEE,kBAAA;AA9BR","sourcesContent":["@media print {\n  @page {\n    margin-left: 0.5in;\n    margin-right: 0.5in;\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  body {\n    print-color-adjust: exact;\n    -webkit-print-color-adjust: exact;\n  }\n}\n\n.bedboard-print-layout {\n  width: 100%;\n  padding-left: 0.7rem !important;\n  padding-right: 0.7rem !important;\n  margin-top: 12px !important;\n\n  @media print {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    transform: none !important;\n    width: unset !important;\n  }\n\n  .bedboard-tables-wrapper {\n    display: grid;\n    gap: 4px;\n    grid-template-columns: repeat(4, 1fr);\n    margin-top: 5px;\n\n    page-break-after: always;\n\n    height: 1155px;\n\n    &-0 {\n      height: 1100px;\n    }\n\n    @media print {\n      height: auto !important;\n      transform: none !important;\n    }\n  }\n}\n\n.export-bedboard-to-pdf-modal {\n  .table-header {\n    b {\n      font-weight: 700;\n    }\n  }\n\n  .modal-header {\n    .pdf-title {\n      word-break: break-all;\n    }\n  }\n\n  .modal-body {\n    width: 100%;\n    overflow-y: visible;\n    overscroll-behavior: none;\n    background-color: #ffffff;\n    max-width: 800px;\n    margin: auto;\n\n    overscroll-behavior: initial;\n\n    ::-webkit-scrollbar {\n      display: none;\n    }\n\n    .bedboard-print-layout {\n      padding: 32px 32px 0;\n    }\n\n    .bedboard-print-layout {\n      max-width: 100%;\n      padding: 0;\n      margin-top: 32px;\n\n      .table-header {\n        font-size: 14px;\n        line-height: 14px;\n\n        @media print {\n          transform: none !important;\n        }\n      }\n\n      .unit-block {\n        width: 176px;\n        page-break-after: always;\n\n        .unit-in-house-title {\n          margin-top: 15px;\n          font-size: 10px;\n          margin-bottom: 0px !important;\n          background-color: transparent;\n\n          @media print {\n            margin-top: 15px !important;\n          }\n        }\n\n        .unit-title {\n          font-size: 14px;\n          margin-top: 5px !important;\n        }\n\n        .unit-table {\n          max-height: unset;\n          margin-top: 15px !important;\n          overflow-y: visible !important;\n          overflow-x: hidden;\n\n          .tr {\n            &.is-first-room-bed:not(:first-child) {\n              .td {\n                border-top: 1px solid #98a2b3;\n              }\n            }\n          }\n\n          .td {\n            padding: 0px 3px;\n            font-size: 11px !important;\n\n            &.room-col {\n              min-width: 40px;\n              width: 40px !important;\n              max-width: 40px !important;\n              overflow: hidden;\n              white-space: nowrap;\n            }\n\n            &.bed-col {\n              min-width: 15px;\n              width: 15px !important;\n              max-width: 15px !important;\n              color: #667085;\n            }\n\n            &.resident-col {\n              min-width: 95px;\n              width: 95px !important;\n              max-width: 95px !important;\n            }\n\n            &.code-col {\n              width: 20px;\n              max-width: 20px;\n              min-width: 20px;\n              text-align: center;\n              font-size: 11px;\n            }\n          }\n        }\n      }\n\n      .unit-in-house-title {\n        font-size: 12px;\n      }\n\n      .unit-title {\n        font-size: 14px;\n      }\n    }\n\n    .notes-print-block {\n      margin-left: 12px;\n      margin-right: 12px;\n      page-break-before: always;\n      .th {\n        padding: 13px 24px;\n      }\n\n      .td {\n        padding: 13px 24px;\n        font-size: 14px !important;\n      }\n\n      .code-col,\n      .amount-col {\n        text-align: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
